import { render, staticRenderFns } from "./CarwashTable.vue?vue&type=template&id=516a2321&"
import script from "./CarwashTable.vue?vue&type=script&lang=js&"
export * from "./CarwashTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports